import {mapActions} from 'vuex';
import {
  ACTION_SHOW_TOAST,
} from '@/store/types';

export default {
  methods: {
    ...mapActions({
      showToast: ACTION_SHOW_TOAST,
    }),
  },
}
